import React, { useState } from "react"
import "./index.css"
import logo from "../../assets/logo.png"
import PFP from "../pfp"
import { Link } from "react-router-dom"

const Nav = ({ nopfp, ...props }) => {
  const [dropped, setDropped] = useState(false)
  return (
    <nav>
      <div
        className={`nav-container ${`${dropped ? "" : "not-dropped"}${
          nopfp ? " nopfp" : ""
        }`}`}
      >
        <div onClick={() => setDropped(!dropped)} className={`anchor-menu`}>
          <i className={"fas fa-fw fa-bars"} />
        </div>
        <img src={logo} className={"logo"} alt={process.env.REACT_APP_NAME} />
        {!nopfp && <PFP user={props.user} />}
        <div className={"dropdown"}>
          
           <Link className={"icon"} to={"/"}>
            <span className="icon">
              <i className="fas fa-box-open fa-home" />
            </span>
            <span>Panel</span>
          </Link>
          <Link className={"icon"} to={"/orders"}>
            <span className="icon">
              <i className="fas fa-box-open fa-fw" />
            </span>
            <span>Orders</span>
          </Link>
          <Link className={"icon"} to={"/bot"}>
            <span className="icon">
              <i className="fas fa-robot fa-fw" />
            </span>
            <span>Bot Panel</span>
          </Link>
          <a className={"icon"} href={"https://discord.gg/THY7A5v"}>
            <span className="icon">
              <i className="fab fa-discord fa-fw" />
            </span>
            <span>Join Server</span>
          </a>
          <a
            className={"icon"}
            href={"https://webhook.premium-studios.com"}
            target="_blank"
          >
            <span className="icon">
              <i className="fas fa-share fa-fw" />
            </span>
            <span>Webhook Sender</span>
          </a>
                    <a
            className={"icon"}
            href={"https://thepremiumhosting.com"}
            target="_blank"
          >
            <span className="icon">
              <i className="fas fa-server fa-fw" />
            </span>
            <span>Hosting</span>
          </a>

          {props.logOut ? (
            <button
              className="btn btn-danger navbar-btn"
              href={"#"}
              onClick={props.logOut}
            >
              Logout
            </button>
          ) : (
            <a
              className="btn btn-primary navbar-btn"
              href={`${process.env.REACT_APP_DISCORD_AUTHORIZE_URL}?client_id=${
                process.env.REACT_APP_CLIENT_ID
              }&redirect_uri=${encodeURIComponent(
                window.location.href.split(/[?#]/)[0]
              )}&response_type=code&scope=identify%20guilds`}
            >
              Login
            </a>
          )}
        </div>
      </div>
    </nav>
  )
}
export default Nav



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js